module.exports = __webpack_public_path__ + "img/junior-error.7732891e.png";